let navigatorRef: null | ((path: string) => void) = null;

export const setNavigator = (navigate: (path: string) => void) => {
  navigatorRef = navigate;
};

export const getNavigator = () => navigatorRef;
